/**
 * Y.js error classifier for corruption reports.
 *
 * Classifies Y.js errors into known categories for better analysis.
 * Pure function - no side effects, easily testable.
 */

import type { YjsErrorType } from './interfaces';

/**
 * Classify a Y.js error into a known category.
 *
 * @param error - The error to classify
 * @returns The classified error type
 */
export function classifyYjsError(error: Error): YjsErrorType {
  const msg = error.message.toLowerCase();

  if (msg.includes('integer out of range')) return 'INTEGER_OUT_OF_RANGE';
  if (msg.includes('unexpected end')) return 'UNEXPECTED_END_OF_DATA';
  if (msg.includes('invalid')) return 'INVALID_DATA';
  if (msg.includes('corrupted')) return 'CORRUPTED_DATA';
  if (msg.includes('decode')) return 'DECODE_ERROR';

  return 'UNKNOWN_YJS_ERROR';
}

/**
 * Convert bytes to hex string for binary preview.
 *
 * @param bytes - The bytes to convert
 * @returns Hex string representation
 */
export function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
